// source: no/jotta/openapi/search/search.v2.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var no_jotta_openapi_file_file_v2_pb = require('../../../../no/jotta/openapi/file/file.v2_pb.js');
goog.object.extend(proto, no_jotta_openapi_file_file_v2_pb);
var no_jotta_openapi_language_pb = require('../../../../no/jotta/openapi/language_pb.js');
goog.object.extend(proto, no_jotta_openapi_language_pb);
var no_jotta_openapi_people_v1_people_v1_pb = require('../../../../no/jotta/openapi/people/v1/people.v1_pb.js');
goog.object.extend(proto, no_jotta_openapi_people_v1_people_v1_pb);
var no_jotta_openapi_ping_pb = require('../../../../no/jotta/openapi/ping_pb.js');
goog.object.extend(proto, no_jotta_openapi_ping_pb);
var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.JoinWaitlistRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.JoinWaitlistResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.PhotoMatch', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.PhotoSearchRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.PhotoSearchResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.SearchRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.SearchResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.WaitlistStatus', null, global);
goog.exportSymbol('proto.no.jotta.openapi.search.v2.WaitlistStatus.Status', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.PhotoMatch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.PhotoMatch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.PhotoMatch.displayName = 'proto.no.jotta.openapi.search.v2.PhotoMatch';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.displayName = 'proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.SearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.search.v2.SearchRequest.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.SearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.SearchRequest.displayName = 'proto.no.jotta.openapi.search.v2.SearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.SearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.SearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.SearchResponse.displayName = 'proto.no.jotta.openapi.search.v2.SearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.search.v2.PhotoSearchRequest.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.PhotoSearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.PhotoSearchRequest.displayName = 'proto.no.jotta.openapi.search.v2.PhotoSearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.search.v2.PhotoSearchResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.PhotoSearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.PhotoSearchResponse.displayName = 'proto.no.jotta.openapi.search.v2.PhotoSearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.displayName = 'proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.displayName = 'proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.displayName = 'proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.displayName = 'proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.displayName = 'proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.displayName = 'proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.WaitlistStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.WaitlistStatus.displayName = 'proto.no.jotta.openapi.search.v2.WaitlistStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.displayName = 'proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.displayName = 'proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.JoinWaitlistRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.displayName = 'proto.no.jotta.openapi.search.v2.JoinWaitlistRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.search.v2.JoinWaitlistResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.displayName = 'proto.no.jotta.openapi.search.v2.JoinWaitlistResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.PhotoMatch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.PhotoMatch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.toObject = function(includeInstance, msg) {
  var f, obj = {
    md5: jspb.Message.getFieldWithDefault(msg, 2, ""),
    thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    photoId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    height: jspb.Message.getFieldWithDefault(msg, 6, 0),
    width: jspb.Message.getFieldWithDefault(msg, 7, 0),
    videoDuration: jspb.Message.getFieldWithDefault(msg, 8, ""),
    debugInfo: (f = msg.getDebugInfo()) && proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.PhotoMatch;
  return proto.no.jotta.openapi.search.v2.PhotoMatch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoMatch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMd5(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhotoId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHeight(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setWidth(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoDuration(value);
      break;
    case 9:
      var value = new proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo;
      reader.readMessage(value,proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.deserializeBinaryFromReader);
      msg.setDebugInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.PhotoMatch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoMatch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMd5();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhotoId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDebugInfo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    similarityScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    linearScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    aestheticScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo;
  return proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSimilarityScore(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLinearScore(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAestheticScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSimilarityScore();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getLinearScore();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getAestheticScore();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional float similarity_score = 1;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.prototype.getSimilarityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.prototype.setSimilarityScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float linear_score = 2;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.prototype.getLinearScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.prototype.setLinearScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float aesthetic_score = 3;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.prototype.getAestheticScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo.prototype.setAestheticScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string md5 = 2;
 * @return {string}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string thumbnail_url = 3;
 * @return {string}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string photo_id = 4;
 * @return {string}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.getPhotoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.setPhotoId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 height = 6;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 width = 7;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string video_duration = 8;
 * @return {string}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.getVideoDuration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.setVideoDuration = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.clearVideoDuration = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.hasVideoDuration = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional DebugInfo debug_info = 9;
 * @return {?proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.getDebugInfo = function() {
  return /** @type{?proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo, 9));
};


/**
 * @param {?proto.no.jotta.openapi.search.v2.PhotoMatch.DebugInfo|undefined} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch} returns this
*/
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.setDebugInfo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.clearDebugInfo = function() {
  return this.setDebugInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.PhotoMatch.prototype.hasDebugInfo = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.search.v2.SearchRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.SearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.SearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.SearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pathList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    pageIndex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.SearchRequest}
 */
proto.no.jotta.openapi.search.v2.SearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.SearchRequest;
  return proto.no.jotta.openapi.search.v2.SearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.SearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.SearchRequest}
 */
proto.no.jotta.openapi.search.v2.SearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addPath(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageIndex(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.SearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.SearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.SearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPathList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getPageIndex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.search.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string path = 2;
 * @return {!Array<string>}
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.getPathList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.no.jotta.openapi.search.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.setPathList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.search.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.addPath = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.search.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.clearPathList = function() {
  return this.setPathList([]);
};


/**
 * optional int32 page_index = 3;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.getPageIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.setPageIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.SearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.SearchRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.SearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.SearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.SearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.SearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    match: (f = msg.getMatch()) && no_jotta_openapi_file_file_v2_pb.PathItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.SearchResponse}
 */
proto.no.jotta.openapi.search.v2.SearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.SearchResponse;
  return proto.no.jotta.openapi.search.v2.SearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.SearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.SearchResponse}
 */
proto.no.jotta.openapi.search.v2.SearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_file_file_v2_pb.PathItem;
      reader.readMessage(value,no_jotta_openapi_file_file_v2_pb.PathItem.deserializeBinaryFromReader);
      msg.setMatch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.SearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.SearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.SearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.SearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatch();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_file_file_v2_pb.PathItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.file.v2.PathItem match = 1;
 * @return {?proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.search.v2.SearchResponse.prototype.getMatch = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.PathItem} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_file_file_v2_pb.PathItem, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.PathItem|undefined} value
 * @return {!proto.no.jotta.openapi.search.v2.SearchResponse} returns this
*/
proto.no.jotta.openapi.search.v2.SearchResponse.prototype.setMatch = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.SearchResponse} returns this
 */
proto.no.jotta.openapi.search.v2.SearchResponse.prototype.clearMatch = function() {
  return this.setMatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.SearchResponse.prototype.hasMatch = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.PhotoSearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, ""),
    debug: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    minimumAestheticScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    personIdList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.PhotoSearchRequest;
  return proto.no.jotta.openapi.search.v2.PhotoSearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDebug(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMinimumAestheticScore(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addPersonId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.PhotoSearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getPersonIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool debug = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.getDebug = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.setDebug = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.clearDebug = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.hasDebug = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float minimum_aesthetic_score = 3;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.getMinimumAestheticScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.setMinimumAestheticScore = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.clearMinimumAestheticScore = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.hasMinimumAestheticScore = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated string person_id = 4;
 * @return {!Array<string>}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.getPersonIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.setPersonIdList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.addPersonId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchRequest.prototype.clearPersonIdList = function() {
  return this.setPersonIdList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.PhotoSearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchesList: jspb.Message.toObjectList(msg.getMatchesList(),
    proto.no.jotta.openapi.search.v2.PhotoMatch.toObject, includeInstance),
    matchedPersonIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.PhotoSearchResponse;
  return proto.no.jotta.openapi.search.v2.PhotoSearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.search.v2.PhotoMatch;
      reader.readMessage(value,proto.no.jotta.openapi.search.v2.PhotoMatch.deserializeBinaryFromReader);
      msg.addMatches(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addMatchedPersonIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.PhotoSearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.search.v2.PhotoMatch.serializeBinaryToWriter
    );
  }
  f = message.getMatchedPersonIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated PhotoMatch matches = 1;
 * @return {!Array<!proto.no.jotta.openapi.search.v2.PhotoMatch>}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.getMatchesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.search.v2.PhotoMatch>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.search.v2.PhotoMatch, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.search.v2.PhotoMatch>} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse} returns this
*/
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.setMatchesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.search.v2.PhotoMatch=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.addMatches = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.search.v2.PhotoMatch, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.clearMatchesList = function() {
  return this.setMatchesList([]);
};


/**
 * repeated string matched_person_ids = 2;
 * @return {!Array<string>}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.getMatchedPersonIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.setMatchedPersonIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.addMatchedPersonIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchResponse} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchResponse.prototype.clearMatchedPersonIdsList = function() {
  return this.setMatchedPersonIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    language: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest;
  return proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.no.jotta.openapi.Language} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional no.jotta.openapi.Language language = 1;
 * @return {!proto.no.jotta.openapi.Language}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.prototype.getLanguage = function() {
  return /** @type {!proto.no.jotta.openapi.Language} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Language} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.prototype.clearLanguage = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsRequest.prototype.hasLanguage = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    suggestedQueriesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse;
  return proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuggestedQueries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuggestedQueriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string suggested_queries = 1;
 * @return {!Array<string>}
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.prototype.getSuggestedQueriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.prototype.setSuggestedQueriesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.prototype.addSuggestedQueries = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse} returns this
 */
proto.no.jotta.openapi.search.v2.PhotoSearchQuerySuggestionsResponse.prototype.clearSuggestedQueriesList = function() {
  return this.setSuggestedQueriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    photoId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    debug: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    minimumAestheticScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest;
  return proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhotoId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDebug(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMinimumAestheticScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhotoId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional string photo_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.getPhotoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest} returns this
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.setPhotoId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool debug = 2;
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.getDebug = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest} returns this
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.setDebug = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest} returns this
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.clearDebug = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.hasDebug = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float minimum_aesthetic_score = 3;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.getMinimumAestheticScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest} returns this
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.setMinimumAestheticScore = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest} returns this
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.clearMinimumAestheticScore = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosRequest.prototype.hasMinimumAestheticScore = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchesList: jspb.Message.toObjectList(msg.getMatchesList(),
    proto.no.jotta.openapi.search.v2.PhotoMatch.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse;
  return proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.search.v2.PhotoMatch;
      reader.readMessage(value,proto.no.jotta.openapi.search.v2.PhotoMatch.deserializeBinaryFromReader);
      msg.addMatches(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.search.v2.PhotoMatch.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PhotoMatch matches = 1;
 * @return {!Array<!proto.no.jotta.openapi.search.v2.PhotoMatch>}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.prototype.getMatchesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.search.v2.PhotoMatch>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.search.v2.PhotoMatch, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.search.v2.PhotoMatch>} value
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse} returns this
*/
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.prototype.setMatchesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.search.v2.PhotoMatch=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.search.v2.PhotoMatch}
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.prototype.addMatches = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.search.v2.PhotoMatch, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse} returns this
 */
proto.no.jotta.openapi.search.v2.FindSimilarPhotosResponse.prototype.clearMatchesList = function() {
  return this.setMatchesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest;
  return proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest} returns this
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    personSuggestionList: jspb.Message.toObjectList(msg.getPersonSuggestionList(),
    no_jotta_openapi_people_v1_people_v1_pb.Person.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse;
  return proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_people_v1_people_v1_pb.Person;
      reader.readMessage(value,no_jotta_openapi_people_v1_people_v1_pb.Person.deserializeBinaryFromReader);
      msg.addPersonSuggestion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPersonSuggestionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      no_jotta_openapi_people_v1_people_v1_pb.Person.serializeBinaryToWriter
    );
  }
};


/**
 * repeated no.jotta.openapi.people.v1.Person person_suggestion = 1;
 * @return {!Array<!proto.no.jotta.openapi.people.v1.Person>}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.prototype.getPersonSuggestionList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.people.v1.Person>} */ (
    jspb.Message.getRepeatedWrapperField(this, no_jotta_openapi_people_v1_people_v1_pb.Person, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.people.v1.Person>} value
 * @return {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse} returns this
*/
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.prototype.setPersonSuggestionList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.people.v1.Person=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.people.v1.Person}
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.prototype.addPersonSuggestion = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.people.v1.Person, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse} returns this
 */
proto.no.jotta.openapi.search.v2.AutoCompleteSearchQueryResponse.prototype.clearPersonSuggestionList = function() {
  return this.setPersonSuggestionList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.WaitlistStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.WaitlistStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    waitlistPosition: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.WaitlistStatus}
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.WaitlistStatus;
  return proto.no.jotta.openapi.search.v2.WaitlistStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.WaitlistStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.WaitlistStatus}
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.search.v2.WaitlistStatus.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWaitlistPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.WaitlistStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.WaitlistStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getWaitlistPosition();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.Status = {
  UNKNOWN: 0,
  INACTIVE: 1,
  ON_WAITLIST: 2,
  ACTIVE: 3
};

/**
 * optional Status status = 1;
 * @return {!proto.no.jotta.openapi.search.v2.WaitlistStatus.Status}
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.prototype.getStatus = function() {
  return /** @type {!proto.no.jotta.openapi.search.v2.WaitlistStatus.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.search.v2.WaitlistStatus.Status} value
 * @return {!proto.no.jotta.openapi.search.v2.WaitlistStatus} returns this
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 waitlist_position = 2;
 * @return {number}
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.prototype.getWaitlistPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.search.v2.WaitlistStatus} returns this
 */
proto.no.jotta.openapi.search.v2.WaitlistStatus.prototype.setWaitlistPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest;
  return proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = msg.getStatus()) && proto.no.jotta.openapi.search.v2.WaitlistStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse;
  return proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.search.v2.WaitlistStatus;
      reader.readMessage(value,proto.no.jotta.openapi.search.v2.WaitlistStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.search.v2.WaitlistStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional WaitlistStatus status = 1;
 * @return {?proto.no.jotta.openapi.search.v2.WaitlistStatus}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.prototype.getStatus = function() {
  return /** @type{?proto.no.jotta.openapi.search.v2.WaitlistStatus} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.search.v2.WaitlistStatus, 1));
};


/**
 * @param {?proto.no.jotta.openapi.search.v2.WaitlistStatus|undefined} value
 * @return {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse} returns this
*/
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse} returns this
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.GetWaitlistStatusResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.JoinWaitlistRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.JoinWaitlistRequest}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.JoinWaitlistRequest;
  return proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.JoinWaitlistRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.JoinWaitlistRequest}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.JoinWaitlistRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.search.v2.JoinWaitlistResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: (f = msg.getStatus()) && proto.no.jotta.openapi.search.v2.WaitlistStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.search.v2.JoinWaitlistResponse}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.search.v2.JoinWaitlistResponse;
  return proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.search.v2.JoinWaitlistResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.search.v2.JoinWaitlistResponse}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.search.v2.WaitlistStatus;
      reader.readMessage(value,proto.no.jotta.openapi.search.v2.WaitlistStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.search.v2.JoinWaitlistResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.search.v2.WaitlistStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional WaitlistStatus status = 1;
 * @return {?proto.no.jotta.openapi.search.v2.WaitlistStatus}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.prototype.getStatus = function() {
  return /** @type{?proto.no.jotta.openapi.search.v2.WaitlistStatus} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.search.v2.WaitlistStatus, 1));
};


/**
 * @param {?proto.no.jotta.openapi.search.v2.WaitlistStatus|undefined} value
 * @return {!proto.no.jotta.openapi.search.v2.JoinWaitlistResponse} returns this
*/
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.search.v2.JoinWaitlistResponse} returns this
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.search.v2.JoinWaitlistResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.no.jotta.openapi.search.v2);
